import { Injectable, Injector } from '@angular/core';
import { BaseGuard } from '@core/ngrx';
import { Store } from '@ngrx/store';
import type { GuardInput } from '@sitecore-jss/sitecore-jss-angular';
import { of, type Observable } from 'rxjs';

import { setE2eTrackingId } from './lead-form.actions';

@Injectable({
  providedIn: 'root',
})
export class E2eTrackingGuard extends BaseGuard {
  protected isStateLoading(): Observable<boolean> {
    return of(false);
  }

  protected override getDispatchActions() {
    return [];
  }

  public override canActivate(input: GuardInput) {
    const e2eTrackingId =
      input.activatedRoute.queryParamMap.get('e2e_tracking_id');
    if (e2eTrackingId) {
      this.store.dispatch(setE2eTrackingId({ e2eTrackingId }));
    }

    return super.canActivate(input);
  }

  constructor(
    private readonly store: Store,
    protected override readonly injector: Injector
  ) {
    super(injector);
  }
}
